export const EditUserIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect width={48} height={48} x={4} y={4} fill="#D1FADF" rx={24} />
    <path
      fill="#333"
      d="M27.375 16.125a5.93 5.93 0 0 1 3.063.82 6.016 6.016 0 0 1 2.242 2.242c.547.93.82 1.951.82 3.063 0 1.04-.246 2.005-.738 2.898a5.977 5.977 0 0 1-1.969 2.188 8.83 8.83 0 0 1 2.652 1.75l3.473-3.473a2.547 2.547 0 0 1 1.832-.738c.73 0 1.349.255 1.86.766.51.51.765 1.13.765 1.859 0 .73-.255 1.349-.766 1.86l-8.832 8.831-3.363.657-1.285.273.273-1.285.657-3.363 4.128-4.13A7.062 7.062 0 0 0 30 28.923a6.515 6.515 0 0 0-2.625-.547 6.788 6.788 0 0 0-3.527.957 7.084 7.084 0 0 0-2.543 2.543c-.62 1.057-.93 2.224-.93 3.5h-1.75c0-1.185.228-2.315.684-3.39a8.578 8.578 0 0 1 1.859-2.762 9.31 9.31 0 0 1 2.789-1.887 6.217 6.217 0 0 1-1.996-2.188 6.09 6.09 0 0 1-.711-2.898 5.93 5.93 0 0 1 .82-3.063 6.079 6.079 0 0 1 2.215-2.242 6.076 6.076 0 0 1 3.09-.82Zm0 1.75c-.802 0-1.54.2-2.215.602a4.408 4.408 0 0 0-1.586 1.585A4.262 4.262 0 0 0 23 22.25c0 .802.191 1.54.574 2.215.401.656.93 1.185 1.586 1.586a4.41 4.41 0 0 0 2.215.574c.802 0 1.531-.191 2.188-.574a4.408 4.408 0 0 0 1.585-1.586 4.254 4.254 0 0 0 .602-2.215c0-.802-.2-1.531-.602-2.188a4.142 4.142 0 0 0-1.585-1.585 4.112 4.112 0 0 0-2.188-.602Zm11.375 8.75a.818.818 0 0 0-.602.246l-8.476 8.477-.328 1.558 1.558-.328 8.477-8.476c.182-.183.273-.383.273-.602a.779.779 0 0 0-.273-.602.808.808 0 0 0-.629-.273Z"
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#ECFDF3"
      strokeWidth={8}
      rx={24}
    />
  </svg>
);
